import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import throttle from 'lodash/throttle';
import { interactionsBlocked } from 'helper/blockUserInteractionHelper';

import User from '../../../../../../helper/currentUser';
import UpdateBlockPerformanceMutation from '../../../../../../mutations/UpdateBlockPerformance';
import WindowScrollHandler from '../../../../../../learner/helper/WindowScrollHandler';

const user = new User();

export default class BlocksPerformanceHandler extends React.Component {
  updateBlockPerformanceMutation = throttle(
    mutationProps => {
      const mutation = new UpdateBlockPerformanceMutation(mutationProps, {
        onSuccess: s => {},
        onFailure: t => {
          console.log('Failed at setProgressMeasureForLearningCard', t);
        }
      });
      mutation.commit();
    },
    10000,
    { leading: false, trailing: true }
  );

  constructor(props) {
    super(props);

    this.blocksData = {};
    this.handlerReadyFlag = false;
    this.sentForImmediateMutation = false;
    const progressMeasure = this.getCardProgressMeasure(true, this.props.cardPerformance, false);
    this.setCardProgress(progressMeasure);
    this.state = {
      videoBlockExists: false,
      videosWatchProgress: 0,
      videoProgressWeight: 0,
      scrolledAllTheWay: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.removeScrollProgress();
      this.blocksData = {};
      this.handlerReadyFlag = false;
      this.sentForImmediateMutation = false;
      this.state.scrolledAllTheWay = false;
      this.cardScrollProgress = {
        forView: 0,
        forMutation: 0
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cardId !== this.props.cardId) {
      // this.removeScrollProgress();
      this.handlerReadyFlag = false;
      this.sentForImmediateMutation = false;
      this.setCardProgress(this.getCardProgressMeasure(true, this.props.cardPerformance, false));
      this.setScrollProgressMeasure(this.cardScrollProgress, false);
      this.updateBlockPerformanceMutation.flush();
    }
  }

  componentWillUnmount() {
    this.removeScrollProgress();
  }

  setCardProgress = progressMeasure => {
    const forView =
      Math.min(progressMeasure, this.props.minProgressMeasure) /
      (this.props.minProgressMeasure || 1);
    // if (this.cardScrollProgress && (forView < this.cardScrollProgress.forView)) {
    //   console.log('LOWW!!');
    // }
    this.cardScrollProgress = {
      forView: forView > 1 ? 1 : forView,
      forMutation: progressMeasure
    };
  };

  setVideosWatchProgress = blocksData => {
    let videoProgresses = 0;
    // let totalVideoLength = 0;
    let videosCount = 0;
    Object.keys(blocksData).forEach(blockPid => {
      const block = blocksData[blockPid];
      if (block.type === 'video') {
        videoProgresses += (block.videoWatchedLength * 100) / Math.floor(block.videoLength);
        videosCount += 1;
      }
    });

    this.state.videosWatchProgress = videoProgresses / videosCount;
    // console.log('this.state.videosWatchProgress::', this.state.videosWatchProgress);
    if (this.handlerReadyFlag) {
      this.setCardProgress(this.getCardProgressMeasure(false, this.props.cardPerformance, true));
      this.setScrollProgressMeasure(this.cardScrollProgress, true);
    }
  };

  getCardProgressMeasure = (init, cardPerformance, considerScroll) => {
    let progressMeasure = 0;
    if (cardPerformance) {
      progressMeasure = cardPerformance.progressMeasure;
      const scrollBasedPM = this.getScrollBasedPM(init);
      if (considerScroll && progressMeasure < scrollBasedPM) {
        progressMeasure = scrollBasedPM > 1 ? 1 : scrollBasedPM;
      }
    }
    return progressMeasure;
  };

  getScrollBasedPM = init => {
    this.windowScrollData = {
      widnowScrollHeight: document.documentElement.scrollHeight,
      windowScrolled: window.pageYOffset + window.innerHeight
    };
    if (init) {
      return 0;
    }
    let scrolledDistance = this.windowScrollData.windowScrolled + this.percentageOfWholeHeight();
    scrolledDistance =
      scrolledDistance > this.percentageOfWholeHeight(true)
        ? this.percentageOfWholeHeight(true)
        : scrolledDistance;
    const textScrollPM =
      scrolledDistance /
      (this.windowScrollData.widnowScrollHeight - this.percentageOfWholeHeight());
    if (!this.state.videoBlockExists) {
      return textScrollPM;
    }
    const finalPM = this.getPMWithVideos(textScrollPM);
    return finalPM;
  };

  getPMWithVideos = textScrollPM => {
    const finalVideoComplete = this.state.videosWatchProgress * this.state.videoProgressWeight;
    const finalTextComplete = textScrollPM * 100 * (1 - this.state.videoProgressWeight);

    return (finalVideoComplete + finalTextComplete) / 100;
  };

  setUpScrollProgress = () => {
    this.setCardProgress(0);
    this.scrollOnTimer && clearTimeout(this.scrollOnTimer);
    this.scrollOnTimer = setTimeout(
      () =>
        WindowScrollHandler.addCallbackObj(
          this.windowScrollCallback.bind(window, this),
          'cardProgressCallback'
        ),
      800
    );
    // console.log('this.scrollTimer:', this.scrollTimer);
    this.scrollTimer && clearTimeout(this.scrollTimer);
    this.scrollTimer = setTimeout(() => this.windowScrollCallback.bind(window, this)(), 800);
  };

  getVideoProgressWeight = blocksData => {
    if (!this.state.videoBlockExists) {
      return 0;
    }
    let totalVideoLength = 0;
    let totalTextLength = 0;
    Object.keys(blocksData).forEach(blockPid => {
      const block = blocksData[blockPid];
      if (block.type === 'video') {
        totalVideoLength += Math.floor(block.length);
      } else if (block.type === 'text') {
        totalTextLength += Math.floor(block.length);
      }
    });

    return (totalVideoLength * 100) / (totalVideoLength + totalTextLength) / 100;
  };

  setScrollProgressMeasure = (cardScrollProgress, doMutation) => {
    const immediateMutation =
      !this.sentForImmediateMutation &&
      this.props.cardPerformance &&
      this.props.cardPerformance.completionStatus !== 'COMPLETE' &&
      cardScrollProgress.forView === 1;
    if (immediateMutation) {
      this.sentForImmediateMutation = true;
    }
    const shouldDoMutation =
      doMutation &&
      this.props.cardPerformance &&
      this.props.cardPerformance.completionStatus !== 'COMPLETE';
    this.props.setScrollPM(
      cardScrollProgress.forMutation,
      cardScrollProgress.forView,
      shouldDoMutation,
      false,
      immediateMutation
    );
  };

  removeScrollProgress = () => {
    this.setCardProgress(0);
    this.state.videoBlockExists = false;
    // this.didUpdateTimer && clearTimeout(this.didUpdateTimer);
    // this.didMountTimer && clearTimeout(this.didMountTimer);
    this.scrollOnTimer && clearTimeout(this.scrollOnTimer);
    this.scrollTimer && clearTimeout(this.scrollTimer);
    WindowScrollHandler.removeCallbackObj('cardProgressCallback');
  };

  percentageOfWholeHeight = effectiveHeight =>
    effectiveHeight
      ? this.windowScrollData.widnowScrollHeight * 0.85
      : this.windowScrollData.widnowScrollHeight - this.windowScrollData.widnowScrollHeight * 0.85;

  checkIfScrollAllTheWay = () => {
    this.windowScrollData = {
      widnowScrollHeight: document.documentElement.scrollHeight,
      windowScrolled: window.pageYOffset + window.innerHeight
    };
    const percentageOfWholeHeight = this.percentageOfWholeHeight();
    return (
      this.windowScrollData.widnowScrollHeight - this.windowScrollData.windowScrolled <
      percentageOfWholeHeight
    );
  };

  windowScrollCallback = () => {
    if (
      !this.cardScrollProgress.forMutation ||
      this.cardScrollProgress.forMutation < 1 ||
      this.props.cardPerformance.completionStatus !== 'COMPLETE'
    ) {
      if (!this.state.scrolledAllTheWay && this.checkIfScrollAllTheWay()) {
        this.state.scrolledAllTheWay = true;
        this.setCardProgress(this.getCardProgressMeasure(false, this.props.cardPerformance, true));
        // debugger;
        this.setScrollProgressMeasure(this.cardScrollProgress, true);
      } else {
        const scrollPM = this.getCardProgressMeasure(false, this.props.cardPerformance, true);
        // console.log(scrollPM, this.cardScrollProgress.forMutation);
        if (scrollPM > this.cardScrollProgress.forMutation || scrollPM === 1) {
          this.setCardProgress(scrollPM);
          // debugger;
          this.setScrollProgressMeasure(this.cardScrollProgress, true);
        }
      }
      // this.setScrollProgressMeasure(this.cardScrollProgress, false);
    } else {
      WindowScrollHandler.removeCallbackObj('cardProgressCallback');
    }
  };

  updateBlockPerformance = blocksData => {
    if (this.props.previewCourse || this.props.guestMode || interactionsBlocked()) {
      return false;
    }
    const blockPerformance = JSON.stringify(blocksData);
    const mutationProps = cloneDeep({
      courseId: this.props.courseId,
      cardId: this.props.cardId,
      userId: user.id(),
      blockPerformance,
      scaledProgressMeasure:
        this.props.card &&
        this.props.card.cardPerformance &&
        this.props.card.cardPerformance.scaledProgressMeasure,
      progressMeasure:
        this.props.card &&
        this.props.card.cardPerformance &&
        this.props.card.cardPerformance.progressMeasure
    });
    this.updateBlockPerformanceMutation(mutationProps);
  };

  handlerReady = () => {
    if (this.props.previewCourse || this.props.guestMode) {
      return false;
    }
    this.handlerReadyFlag = true;
    this.state.videoProgressWeight = this.getVideoProgressWeight(this.blocksData);
    this.setUpScrollProgress();
    // console.log('handler ready!', this.blocksData);
  };

  updateBlocksData = oneBlockData => {
    this.blocksData[oneBlockData.pid] = oneBlockData;
    if (oneBlockData.type === 'video') {
      // console.log('this.blocksData::', oneBlockData.videoWatchedLength);
      this.state.videoBlockExists = true;
      this.setVideosWatchProgress(this.blocksData);
    }
    if (
      !this.handlerReadyFlag &&
      Object.keys(this.blocksData).length === this.props.blocks.length
    ) {
      this.handlerReady();
    }

    if (this.handlerReadyFlag) {
      this.updateBlockPerformance(this.blocksData);
    }
  };

  render() {
    return null;
  }
}
